import { render, staticRenderFns } from "./EventSidebar.vue?vue&type=template&id=0cb539c8&"
import script from "./EventSidebar.vue?vue&type=script&lang=js&"
export * from "./EventSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EventSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports